/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */
const original = require('../../../../packages/design-system/theme/src/components.tsx');

module.exports = Object.assign({}, original, {
	themed: (propsToValues) => (props) => {
		const vals = typeof propsToValues === 'function' ? propsToValues(props) : propsToValues;
		return vals.light;
	},
});

if (original.__esModule) Object.defineProperty(module.exports, '__esModule', { value: true });
